import type { ApiService } from '@/core/http/services/ApiService'
import type { DataResponse, PaginatedResponse } from '@/core/http/services/types'
import type {
  MinimalPromo,
  Promo,
  PromoRequest,
  PromoWithGroupedProducts,
} from '@/core/http/services/promo/types'
import type { AxiosResponse } from 'axios'

export class PromoService {
  constructor(private readonly service: ApiService) {}

  private path(): string {
    return `/api/promos`
  }

  async slug(slug: string): Promise<AxiosResponse<DataResponse<PromoWithGroupedProducts>>> {
    return this.service.client.get<DataResponse<PromoWithGroupedProducts>>(
      `/api/frontend/promo/${slug}`,
    )
  }

  async show(id: number): Promise<AxiosResponse<DataResponse<Promo>>> {
    return this.service.client.get<DataResponse<Promo>>(`${this.path()}/${id}`)
  }

  async active(): Promise<AxiosResponse<DataResponse<MinimalPromo[]>>> {
    return this.service.client.get<DataResponse<MinimalPromo[]>>(`api/active-promos`)
  }

  async index(page: number): Promise<AxiosResponse<PaginatedResponse<Promo[]>>> {
    return this.service.client.get<PaginatedResponse<Promo[]>>(this.path(), {
      params: {
        page: page,
      },
    })
  }

  async store(request: PromoRequest): Promise<AxiosResponse<DataResponse<Promo>>> {
    return this.service.client.post<DataResponse<Promo>>(this.path(), request)
  }

  async update(id: number, request: PromoRequest): Promise<AxiosResponse<DataResponse<Promo>>> {
    return this.service.client.put<DataResponse<Promo>>(`${this.path()}/${id}`, request)
  }
}
